module.exports = __webpack_public_path__ + "img/11-3.3b4c8955.jpg";